import axios from 'axios';

import SiteHeader from '../../components/shared/SiteHeader';
import CourseListing from '../../components/local/courses/CourseListing';

import { getStrapiURL } from '../../lib/api';
import EventBanner from '@components/shared/bytes/EventBanner';
const apiBaseUrl = getStrapiURL();

const Course = ({ courseData, degreeData, error, seo }) => {
  if (error)
    return <div className="m-20 flex items-center justify-center">500 | Internal Server Error</div>;
  return (
    <>
      <SiteHeader
        title={'Explore AlmaBetter’s courses to start your learning journey '}
        desc={
          'We offer intensive and industry-relevant courses to learners. Our programs are designed with the help of industry experts to offer the best learning experience.'
        }
        url={'/courses'}
        image={seo?.image?.data?.attributes?.url}
      />
      <div className="w-full">
        <CourseListing courseData={courseData} />
        <div className="mx-16 mb-10">
          <EventBanner />
        </div>
      </div>
    </>
  );
};

export default Course;

export async function getStaticProps({ params }) {
  try {
    const { data } = await axios.get(
      `${apiBaseUrl}/api/courses?populate=courseIcon,upcomingBatches,courseDetails.DetailsMetric.icon&populate=*`
    );
    const { data: seoData } = await axios.get(`${apiBaseUrl}/api/global?populate=seo.image`);
    let courseData = data?.data;
    // courseData = courseData.filter((c) => c.attributes.courseType !== 'web3');
    return { props: { courseData, seo: seoData.data.attributes.seo }, revalidate: 3600 };
  } catch (error) {
    return { props: { error } };
  }
}
